// Persist the language choice for a logged-in user so provider lifecycle emails
// and push arrive in the right language. Anonymous visitors keep localStorage only.
import { API_URL } from "src/utils/apiUrl";
import { authHeaders, jsonOrThrow } from "src/utils/apiFetch";
import { captureError } from "src/utils/errorReporting";

export async function saveLanguagePreference({ token, language }) {
    if (!token) return { success: false };
    try {
        const res = await fetch(`${API_URL}/api/pumppuRequests/me/language`, {
            method: "PATCH",
            headers: { "Content-Type": "application/json", ...authHeaders(token) },
            body: JSON.stringify({ language }),
        });
        await jsonOrThrow(res);
        return { success: true };
    } catch (error) {
        captureError(error, { tags: { entity: "personSettings", operation: "saveLanguage", swallowed: true } });
        return { success: false };
    }
}
